import { useState, useEffect } from "react";

const getLocation = () => ({
  hash: window.location.hash,
  host: window.location.host,
  hostname: window.location.hostname,
  href: window.location.href,
  origin: window.location.origin,
  pathname: window.location.pathname,
  port: window.location.port,
  protocol: window.location.protocol,
  search: window.location.search,
});

const checkMatch = {
  start: (path, match) => path.startsWith(match.substring(0, match.length - 1)),
  end: (path, match) => path.endsWith(match.substring(1)),
  includes: (path, match) => path.includes(match.substring(1, match.length - 1)),
  exact: (path, match) => path === match,
};

const isMatch = (path, match) => {
  if (!match || match === "*") return "exact";

  if (!(match instanceof Array)) match = [match];

  return match.find((match) => {
    let checkType = match.endsWith("*") ? "start" : "exact";

    if (match.startsWith("*")) checkType = checkType === "start" ? "includes" : "end";

    return checkMatch[checkType](path, match);
  });
};

const useLocation = (match) => {
  const [location, setLocation] = useState(getLocation);

  useEffect(() => {
    const locationchange = () => {
      setLocation(getLocation());
    };
    window.addEventListener("locationchange", locationchange);
    return () => {
      window.removeEventListener("locationchange", locationchange);
    };
  }, []);

  return match ? { ...location, isMatch: isMatch(location.pathname, match) } : location;
};
export default useLocation;

window.history.pushState = ((f) =>
  function pushState() {
    const ret = f.apply(this, arguments);
    window.dispatchEvent(new Event("pushstate"));
    window.dispatchEvent(new Event("locationchange"));
    return ret;
  })(history.pushState);

history.replaceState = ((f) =>
  function replaceState() {
    const ret = f.apply(this, arguments);
    window.dispatchEvent(new Event("replacestate"));
    window.dispatchEvent(new Event("locationchange"));
    return ret;
  })(history.replaceState);

window.addEventListener("popstate", () => {
  window.dispatchEvent(new Event("locationchange"));
});
